import React from 'react'
import styled from 'styled-components'
import Share from '@/components/Common/Share'
import { format, parseISO } from 'date-fns'
import esLocale from 'date-fns/locale/es'

const Wrap = styled.div`
  display: grid;
  grid-template-columns: repeat(8, minmax(0, 1fr));
  gap: 0.5rem;
  margin-bottom: 2rem;
  font-family: 'Futura', sans-serif;
  font-size: 0.7rem;
  .font-inter {
    font-family: 'Futura', sans-serif !important;
    color: black;
    font-size: 0.7rem;
  }
`
const Col = styled.div`
  grid-column: span 4;
  span {
    letter-spacing: normal;
  }
`

const Data = styled.div`
  font-size: 1rem;
  line-height: 1;
`

const PostMeta = ({ date, author, authorsite, authorsiteurl, slug }) => {
  return (
    <Wrap>
      <Col>
        <span>POR:</span>
        <Data>{author}</Data>
        {authorsiteurl && (
          <a
            className="block"
            href={authorsiteurl}
            target="_blank"
            rel="noopener noreferrer">
            ({authorsite})
          </a>
        )}
      </Col>
      <Col>
        <Share
          url={`https://especiales.latercera.com/fiesta-universal-60-anos-de-un-mundial/${slug}/`}
          title={`Fiesta universal: 60 años de un mundial - La Tercera`}
          twitterhandle="latercera"
          hashtags={[]}
        />
      </Col>
    </Wrap>
  )
}

export default PostMeta
